var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13336 16C2.76669 16 2.45281 15.8694 2.19169 15.6083C1.93058 15.3472 1.80003 15.0333 1.80003 14.6667V2H0.888916V0.666667H5.06669V0H10.9334V0.666667H15.1111V2H14.2V14.6667C14.2 15.0222 14.0667 15.3333 13.8 15.6C13.5334 15.8667 13.2223 16 12.8667 16H3.13336ZM12.8667 2H3.13336V14.6667H12.8667V2ZM5.48892 12.7556H6.82225V3.88889H5.48892V12.7556ZM9.17781 12.7556H10.5111V3.88889H9.17781V12.7556Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteOutline);
export default __webpack_public_path__ + "static/media/icon_delete_outline.8f7a7642aa7e0e8c77c9e972964435a3.svg";
export { ForwardRef as ReactComponent };